import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function PaymeCancelBridge() {
  const [sp] = useSearchParams();
  const pid = Number(sp.get("pid") || 0);

  useEffect(() => {
    try {
      window.parent.postMessage(JSON.stringify({ type: "payme_cancel", pid }), window.location.origin);
    } catch (_) {}
  }, [pid]);

  return (
    <div style={{ padding: 16, fontFamily: "Arial", direction: "rtl" }}>
      התשלום בוטל. מחזירים אותך…
    </div>
  );
}
